import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { ZohoSyncRequestAddModel } from 'src/app/admin/models/zoho.sync.request.add.model';
import { ZohoSyncRequestService } from 'src/app/admin/services/zoho.sync.request.service';
import { AppUtils } from 'src/app/helpers/app.utils';
import { ZohoSyncRequestType } from 'src/app/helpers/enums';

@Component({
    selector: 'app-getty-order-zoho-sync-dialog',
    templateUrl: './getty.order.zoho.sync.dialog.component.html',
})

export class GettyOrderZohoSyncComponent {
    startDate: any;
    endDate: any;
    model = new ZohoSyncRequestAddModel();

    constructor(public activeModal: NgbActiveModal,
        private zohoSyncService: ZohoSyncRequestService,
        private toastr: ToastrService,
        private spinner: NgxSpinnerService) {}

    close(): void {
        this.activeModal.close();
    }

    submit(): void {
        this.model.startDate = AppUtils.getFormattedDate(this.startDate);
        this.model.endDate = AppUtils.getFormattedDate(this.endDate);
        this.model.type = ZohoSyncRequestType.Bills;
        this.spinner.show();
        this.zohoSyncService.syncBills(this.model).subscribe(() => {
            this.spinner.hide();
            setTimeout(() => {
                this.close();
            });
            this.toastr.success('Bill syncing job has started successfully.');
        }, error => {
            this.spinner.hide();
            AppUtils.processErrorResponse(this.toastr, error);
        });
    }

}
